import { Component, Input, OnInit } from '@angular/core';
import { FaturaAciklama } from 'src/model/fatura-aciklama';
import { TalepAciklama } from 'src/model/talep-aciklama';

@Component({
  selector: 'app-aciklama-gecmisi',
  templateUrl: './aciklama-gecmisi.component.html',
  styleUrls: ['./aciklama-gecmisi.component.scss']
})
export class AciklamaGecmisiComponent implements OnInit {

  aciklamaGecmisiTalep: TalepAciklama[];
  aciklamaGecmisiFatura: FaturaAciklama[];

  @Input()
  public set source(talepAciklama: TalepAciklama[]) {
    if (talepAciklama != null) {
      this.aciklamaGecmisiTalep = talepAciklama;
    }
  }

  @Input()
  public set source2(faturaAciklama: FaturaAciklama[]) {
    if (faturaAciklama != null) {
      this.aciklamaGecmisiFatura = faturaAciklama;
    }
  }

  constructor() { }

  ngOnInit() {
  }

}
